import React from "react";
import { HiOutlineMail } from "react-icons/hi";

const Newsletter = () => {
  return (
    <section className="w-full bg-gradient-to-r from-[#6d0608] to-[#a50000] text-white py-14 sm:py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight">
          Stay Updated with Latest Gaming News
        </h2>

        <p className="text-gray-200 mb-8 max-w-2xl mx-auto text-sm sm:text-base">
          Subscribe to our newsletter and get exclusive deals, new releases,
          and gaming tips.
        </p>

        <form className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-xl mx-auto w-full">
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full px-5 py-3 rounded-md bg-black/40 border border-white/20 focus:outline-none focus:border-white text-white placeholder-gray-300"
          />

          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-white font-bold rounded-md text-red hover:opacity-90 transition flex items-center justify-center gap-2"
          >
            <HiOutlineMail />
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
